/**
 * Application Configuration
 * 
 * SINGLE SOURCE OF TRUTH for all configuration values.
 * This ensures the frontend ALWAYS talks to Railway, never Vercel.
 */

// Railway backend URL - The ONLY backend endpoint
// NEVER change this fallback to localhost or Vercel
const rawApiUrl = import.meta.env.VITE_API_URL || 'https://flash-usdt-production.up.railway.app';

// Ensure URL always has protocol to prevent relative path issues
export const API_BASE_URL = rawApiUrl.startsWith('http') 
  ? rawApiUrl 
  : `https://${rawApiUrl}`;

/**
 * Get full API URL for a given path
 * @param path - API endpoint path (e.g., '/api/health' or 'api/health')
 */
export const getApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

// Export for debugging
export const isProduction = import.meta.env.PROD;
export const isDevelopment = import.meta.env.DEV;
